import ZRadio from './radio.vue'

ZRadio.install = function(app) {
  app.component(ZRadio.name, ZRadio)
}

export default ZRadio